export enum RideStatusEnum {
  Draft = "Draft",
  New = "New",
  Approved = "Approved",
  Rejected = "Rejected",
  Sent = "Sent",
  Received = "Received",
  OnRoute = "OnRoute",
  Done = "Done",
  DoneApproved = "DoneApproved",
  Canceled = "Canceled",
  Sending = "Sending",
  Declined = "Declined",
}
